export enum PressingForceTableToolType {
  STANDARD_TOOL = 'STANDARD_TOOL',
  FOLDING = 'FOLDING',
  ROLL_BEND = 'ROLL_BEND',
}
